const Mutations = Object.freeze({
	SET_REPORTS: 'dataExports/SET_REPORTS',
	SET_LOADING_REPORTS: 'dataExports/SET_LOADING_REPORTS',
});
export const Actions = Object.freeze({
	LOAD: 'dataExports/LOAD',
	CLEAR: 'dataExports/CLEAR',
	EXPORT: 'dataExports/EXPORT',
});
export const Getters = Object.freeze({
	REPORTS: 'dataExports/REPORTS',
	LOADING_REPORTS: 'dataExports/LOADING_REPORTS',
});

import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/dataExportService';
import exportDataService from '../../../../../services/data/dataExportService';
import fileUtils from '../../../../../utils/fileUtils';
import { ExportMode } from '../../../../../enums/ExportMode';

export default {
	state: {
		reports: [],
		loadingReports: false,
	},
	mutations: {
		[Mutations.SET_REPORTS](state, reports) {
			state.reports = reports;
		},
		[Mutations.SET_LOADING_REPORTS](state, isLoading) {
			state.loadingReports = isLoading;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_REPORTS, []);
				commit(Mutations.SET_LOADING_REPORTS, false);
				resolve();
			});
		},

		[Actions.LOAD]({ commit, dispatch }) {
			commit(Mutations.SET_LOADING_REPORTS, true);
			dataService
				.loadDataExportsReports()
				.then((response) => {
					commit(Mutations.SET_REPORTS, response.data);
				})
				.catch((error) => {
					dispatch(GeneralActions.ERROR, error);
				})
				.finally(() => {
					commit(Mutations.SET_LOADING_REPORTS, false);
				});
		},
		[Actions.EXPORT](
			{ dispatch },
			{ isDirectMode = ExportMode.DIRECT, ...payload }
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);

				if (isDirectMode === ExportMode.DIRECT) {
					// Direct export mode - immediate download
					exportDataService
						.downloadDataExportsDirect(payload)
						.then((resp) => {
							const serverFilename =
								fileUtils.extractFileNameFromResponse(resp);
							const filename =
								serverFilename ||
								`DataExport_${new Date()
									.toISOString()
									.slice(0, 19)
									.replace(/:/g, '-')}.xlsx`;

							const blob = new Blob([resp.data], {
								type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename);
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);

							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				} else {
					// Background export mode - with notification
					exportDataService
						.downloadDataExports(payload)
						.then(() => {
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				}
			});
		},
	},
	getters: {
		[Getters.LOADING_REPORTS]: (state) => {
			return state.loadingReports;
		},
		[Getters.REPORTS]: (state) => {
			if (!state.reports) return [];
			if (state.reports.length <= 0) return [];

			const reports = JSON.parse(JSON.stringify(state.reports));

			// Separate reports with null workbookId and non-null workbookId
			const nullWorkbookReports = reports.filter(
				(report) => report.WorkbookId === null
			);
			const nonNullWorkbookReports = reports.filter(
				(report) => report.WorkbookId !== null
			);

			// Sort null workbookId reports by ReportName
			nullWorkbookReports.sort((a, b) =>
				a.ReportName > b.ReportName ? 1 : -1
			);

			// Sort non-null workbookId reports by WorkbookName first, then by Order
			nonNullWorkbookReports.sort((a, b) => {
				if (a.WorkbookName !== b.WorkbookName) {
					return a.WorkbookName > b.WorkbookName ? 1 : -1;
				}
				return a.Order - b.Order;
			});

			// Combine the two sorted arrays, with null workbookId reports first
			return [...nullWorkbookReports, ...nonNullWorkbookReports];
		},
	},
};
